import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { Routes } from 'routing';

import StoresList from './StoresList';
import NewStore from './NewStore';
import { useHasFeature } from 'hooks/useHasFeature';

const Stores = () => {
	const { hasFeature } = useHasFeature();
	return (
		<Switch>
			<Route exact path={Routes.ACCOUNT_STORES} component={StoresList} />
			{hasFeature('STORES') && <Route path={Routes.ACCOUNT_STORES_NEW} component={NewStore} />}

			<Redirect to={Routes.ACCOUNT_STORES} />
		</Switch>
	);
};

export default Stores;
